module.exports = __webpack_public_path__ + "static/solicitacao-3483700a31814620230f345adb20fd07.pdf";